export const heroSlides = [
  {
    id: 1,
    title: "Dem Çarşı",
    subtitle: "Dem Çarşı ile modern altyapı ve güçlü lojistik",
    location: "Diyarbakır, Kayapınar, Çölgüzeli",
    image: "/images/IMG_8567.JPG",
    link: "/projeler/dem-carsi"
  },
  {
    id: 2,
    title: "Dem Bungalov",
    subtitle: "Ahşap sıcaklığıyla özgün ve huzurlu yaşam",
    location: "Diyarbakır, Bağlar, Zoğa",
    image: "/images/IMG_8568.JPG",
    link: "/projeler/dem-bungalov"
  },
  {
    id: 3,
    title: "Dem Köy Villaları",
    subtitle: "Işığı içeri alan, mutluluğu dışarı vuran",
    location: "Diyarbakır, Bağlar, Zoğa",
    image: "/images/IMG_8570.jpg",
    link: "/projeler/dem-koy-villa"
  },
  {
    id: 4,
    title: "Dem Çarşı",
    subtitle: "İş dünyasının yeni merkezi",
    location: "Diyarbakır, Kayapınar, Çölgüzeli",
    image: "/images/IMG_8569.JPG",
    link: "/projeler/dem-carsi"
  },
  {
    id: 5,
    title: "Sterk Konutları",
    subtitle: "Hayat 2+1'e sığar, yanlış projeye sığmaz",
    location: "Diyarbakır, Sur, Çaruği",
    image: "/images/IMG_8571.JPG",
    link: "/projeler/dem-sterk-konutlari"
  }
];

export const landProjects = [
  {
    id: 1,
    name: "Dem Çarşı A-B-C Blok",
    location: "Diyarbakır, Kayapınar",
    district: "Kayapınar",
    status: "Satışta",
    type: "Depo",
    image: "/images/dem-3.jpg",
    slug: "dem-carsi",
    category: "depo",
    units: "Depo",
    deliveryDate: "2025 Q3",
    info1: "Diyarbakır Kayapınar ilçesi Çölgüzeli mevkiinde, 25 dönüm arazi üzerine inşa edilerek tamamlanan depo projesi; lojistik, ticaret ve depolama ihtiyaçlarına üst düzey çözümler sunmak üzere tasarlanmıştır. Stratejik konumu sayesinde şehir içi ve şehirlerarası ulaşım akslarına hızlı ve kolay erişim imkânı sağlar.",
    info2: "Tüm bloklar; yüksek tavanlı yapıları,asma katları ile birlikte geniş yükleme–boşaltma alanları ve işlevsel planlamalarıyla farklı sektörlerin kullanımına uygundur. Projenin elektrik, su, doğalgaz, fiber, kanalizasyon, yol ve çevre düzenlemeleri dâhil tüm altyapı çalışmaları eksiksiz şekilde tamamlanmış olup, depolar kullanıma hazır durumdadır.",
    feature1: "A Blok’ta net 400 m² kullanım alanına sahip 7 adet dükkân,",
    feature2: "B Blok’ta net alanları 400 m² ile 800 m² arasında değişen 10 adet dükkân,",
    feature3: "C Blok’ta ise net 580 m² ile 615 m² aralığında 12 adet dükkân yer almaktadır.",
  },
  {
    id: 2,
    name: "Dem Çarşı D Blok",
    location: "Diyarbakır, Kayapınar",
    district: "Kayapınar",
    status: "Satışta",
    type: "Depo",
    image: "/images/dem-4.JPG",
    slug: "dem-carsi-d",
    category: "depo",
    units: "Depo",
    deliveryDate: "2025 Q3",
    info1: "Diyarbakır Kayapınar Çölgüzeli mevkiinde, toplam 8 dönüm arazi üzerine inşa edilen Depo 2. Etap Projesi başarıyla tamamlanmıştır. Proje kapsamında tüm altyapı çalışmaları eksiksiz şekilde bitirilmiş olup, kullanıma hazır durumdadır.",
    info2: "D Blok olarak adlandırılan 2. Etap, toplam 12 adet dükkândan oluşmaktadır. Her biri farklı ihtiyaçlara cevap verecek şekilde planlanan alanlar, 400 m² ile 800 m² arasında değişen kullanım alanlarına sahiptir.",
    info3: "Lojistik, depolama ve ticari faaliyetler için uygun şekilde tasarlanan proje; konumu, altyapı kalitesi ve fonksiyonel planlamasıyla yatırımcılar ve işletmeler için güçlü bir çözüm sunmaktadır. Modern yapısı ve erişilebilir lokasyon avantajı sayesinde bölgedeki ticari potansiyele değer katmaktadır.",
    feature1: "A Blok’ta net 400 m² kullanım alanına sahip 7 adet dükkân,",
    feature2: "B Blok’ta net alanları 400 m² ile 800 m² arasında değişen 10 adet dükkân,",
    feature3: "C Blok’ta ise net 580 m² ile 615 m² aralığında 12 adet dükkân yer almaktadır.",
  }
];

export const residentialProjects = [
  {
    id: 1,
    name: "Sterk Konutları",
    location: "Diyarbakır,Çarıklı",
    district: "Çarıklı",
    status: "Yapımda",
    type: "Konut",
    home: true,
    image: "/images/dem-5.JPG",
    slug: "dem-sterk-konutlari",
    category: "konut",
    units: "2+1",
    info1: "Diyarbakır’ın tarihi dokusuyla bütünleşen Çarıklı bölgesinde, tepe hakimiyetine sahip konumuyla öne çıkan bu özel proje; Dicle Nehri manzarasını yaşam alanlarına taşıyor. Şehrin gürültüsünden uzak, ancak merkezle bağlantısını koparmayan lokasyonu sayesinde hem huzurlu hem de erişilebilir bir yaşam sunuyor.",
    info2: "Modern mimari anlayışıyla tasarlanan 2+1 86m2 net daireler; ferah iç planlaması, gün boyu doğal ışık alan yaşam alanları ve manzarayı maksimum seviyede değerlendiren balkonlarıyla konforu yeniden tanımlıyor. Her detay, günlük yaşamı kolaylaştırmak ve yaşam kalitesini yükseltmek amacıyla özenle planlandı.",
    info3: "Doğayla iç içe konumu, güçlü altyapısı ve yatırım değeri yüksek lokasyonu ile bu proje; hem oturum hem de uzun vadeli kazanç arayanlar için ayrıcalıklı bir fırsat sunuyor.",
    feature1: "Modern ve şık mimari tasarım",
    feature2: "Geniş sosyal tesis alanları",
    feature3: "24 saat güvenlik hizmeti",
    feature4: "Yeşil alanlar ve peyzaj düzenleme",
    feature5: "Açık otopark",
    feature6: "Yüzme havuzu ve fitness merkezi",
    feature7: "Gündüz Bakım Evi",
    feature8: "Elektrik Şarj İstasyonu",
    feature9: "Güneş Enerji Sistemi ile Elektrik Tasarrufu",
    feature10: "Merkezi Sistem ile Yerden ısıtma",
  },
  {
    id: 2,
    name: "Dem Köy Villaları",
    location: "Diyarbakır,Bağlar,Zoğa",
    district: "Bağlar",
    status: "Yapımda",
    type: "Villa",
    home: true,
    image: "/images/dem-villa1.JPG",
    slug: "dem-koy-villa",
    category: "villa",
    units: "4+1 ve 5+1",
    info1: "Diyarbakır Bağlar Zoğa mevkiinde, 203 dönümlük geniş bir alan üzerine konumlanan villa projesi; standart kalıpların dışına çıkan, özgürlük temelli bir yaşam anlayışıyla tasarlanmıştır. Bu projede yalnızca bir villa değil, kendi yaşam tarzınızı inşa edersiniz.",
    info2: "Proje kapsamında villa yerleşimi ve konumlandırma özgürlüğü tamamen size aittir.Mimari bütünlüğün korunması amacıyla dış cephe renkleri belirlenen renk paletiyle sınırlandırılmış olup, bu sayede proje genelinde estetik ve düzen sağlanmaktadır.",
    info3: "Bununla birlikte iç mimari ve iç dizayn tamamen sizin kontrolünüzdedir.Planlamadan detaylara kadar her aşamayı kendiniz tasarlayabilir, hayal ettiğiniz yaşam alanını birebir hayata geçirebilirsiniz.",
    info4: "İster proje bünyesindeki profesyonel ekiplerle anahtar teslim olarak, ister tamamen kendi ekiplerinizle ilerleyerek yapım sürecini özgürce yönetebilirsiniz.Farklı, özgün ve size ait bir yaşam alanı arayanlar için bu proje; Zoğa’da benzersiz bir alternatif sunmaktadır.",
  },
  {
    id: 3,
    name: "Dem Bungalov",
    location: "Diyarbakır,Bağlar,Zoğa",
    district: "Bağlar",
    status: "Yapımda",
    type: "Konut",
    home: true,
    image: "/images/dem-2.jpg",
    slug: "dem-bungalov",
    category: "bungalov",
    units: "Bungalov",
    deliveryDate: "2028 Q1",
    info1: "Doğayla İç İçe, Suyun Kıyısında Bir Yaşam",
    info2: "Diyarbakır Bağlar Zoğa mevkiinde, Eğertutmaz Deresi’ne sıfır konumda yer alan bu özel proje; 25100m²’lik geniş bir arazi üzerine konumlandırılmış, doğayla uyumu esas alan bungalov konseptiyle hayata geçirilmek üzere",
    info3: "50 m²’lik modern ve fonksiyonel yapısı, dere manzarasını kesintisiz şekilde iç mekâna taşırken; suyun sesi, yeşilin huzuru, ve açık manzara günün her anında yaşamın bir parçası hâline gelir. Eğertutmaz Deresi’ne komşu bu benzersiz konum, projeye sadece bir manzara değil, aynı zamanda doğal bir atmosfer ve sakin bir yaşam ritmi kazandırır.",
    info4: "Şehirden kopmadan, doğanın kalbinde nefes almak isteyenler için tasarlanan bu bungalov yapısı; hafta sonu kaçamağı, dinlenme alanı ya da alternatif yaşam modeli arayanlar için güçlü bir seçenek sunar.",
  },
  {
    id: 4,
    name: "Dem Çarşı A-B-C Blok",
    location: "Diyarbakır, Kayapınar",
    district: "Kayapınar",
    status: "Satışta",
    type: "Depo",
    image: "/images/dem-3.jpg",
    slug: "dem-carsi",
    category: "depo",
    units: "Depo",
    info1: "Diyarbakır Kayapınar ilçesi Çölgüzeli mevkiinde, 25 dönüm arazi üzerine inşa edilerek tamamlanan depo projesi; lojistik, ticaret ve depolama ihtiyaçlarına üst düzey çözümler sunmak üzere tasarlanmıştır. Stratejik konumu sayesinde şehir içi ve şehirlerarası ulaşım akslarına hızlı ve kolay erişim imkânı sağlar.",
    info2: "Tüm bloklar; yüksek tavanlı yapıları,asma katları ile birlikte geniş yükleme–boşaltma alanları ve işlevsel planlamalarıyla farklı sektörlerin kullanımına uygundur. Projenin elektrik, su, doğalgaz, fiber, kanalizasyon, yol ve çevre düzenlemeleri dâhil tüm altyapı çalışmaları eksiksiz şekilde tamamlanmış olup, depolar kullanıma hazır durumdadır.",
    feature1: "A Blok’ta net 400 m² kullanım alanına sahip 7 adet dükkân,",
    feature2: "B Blok’ta net alanları 400 m² ile 800 m² arasında değişen 10 adet dükkân,",
    feature3: "C Blok’ta ise net 580 m² ile 615 m² aralığında 12 adet dükkân yer almaktadır.",
  },
  {
    id: 5,
    name: "Dem Çarşı D Blok",
    location: "Diyarbakır, Kayapınar",
    district: "Kayapınar",
    status: "Satışta",
    type: "Depo",
    image: "/images/dem-4.JPG",
    slug: "dem-carsi-d",
    category: "depo",
    units: "Depo",
    info1: "Diyarbakır Kayapınar Çölgüzeli mevkiinde, toplam 8 dönüm arazi üzerine inşa edilen Depo 2. Etap Projesi başarıyla tamamlanmıştır. Proje kapsamında tüm altyapı çalışmaları eksiksiz şekilde bitirilmiş olup, kullanıma hazır durumdadır.",
    info2: "D Blok olarak adlandırılan 2. Etap, toplam 12 adet dükkândan oluşmaktadır. Her biri farklı ihtiyaçlara cevap verecek şekilde planlanan alanlar, 400 m² ile 800 m² arasında değişen kullanım alanlarına sahiptir.",
    info3: "Lojistik, depolama ve ticari faaliyetler için uygun şekilde tasarlanan proje; konumu, altyapı kalitesi ve fonksiyonel planlamasıyla yatırımcılar ve işletmeler için güçlü bir çözüm sunmaktadır. Modern yapısı ve erişilebilir lokasyon avantajı sayesinde bölgedeki ticari potansiyele değer katmaktadır."
  },
  {
    id: 6,
    name: "Dem Baş Sitesi",
    location: "Diyarbakır, Bağlar",
    district: "Bağlar",
    status: "Teslim Edildi",
    type: "Konut",
    home: true,
    image: "/images/dem-6.JPG",
    slug: "dem-bas-sitesi",
    category: "konut",
    units: "1+1, 2+1 ve 3+1",
    info1: "Diyarbakır Bağlar ilçesi Bağcılar Mahallesi’nde konumlanan Dem Baş Sitesi, modern mimarisi ve fonksiyonel yaşam alanlarıyla konforlu bir hayat sunuyor. Toplamda 3 bloktan oluşan proje, zemin + 7 kat olmak üzere 8 katlı yapısıyla bölgenin dikkat çeken projelerinden biridir.",
    info2: "Toplam 3914 m² parsel alanı üzerine kurulu olan proje, geniş ve ferah yaşam alanlarıyla aile yaşamına uygun şekilde tasarlanmıştır.",
    info3: "Dem Baş Sitesi, sadece bir konut değil; aynı zamanda yaşam kalitenizi yükselten bir yaşam alanıdır.",
    feature1: "1 adet 1+1 daire Brüt: 65 m² | Net: 50 m²",
    feature2: "1 adet 2+1 daire Brüt: 80 m² | Net: 65 m²",
    feature3: "47 adet 3+1 daire Brüt: 131 m² | Net: 110 m²",
    feature4: "Çocuk oyun parkı",
    feature5: "7/24 güvenlik",
    feature6: "Jeneratör sistemi",
    feature7: "Kamelya ve dinlenme alanları",
    feature8: "Araç otoparkı",
    feature9: "780 m² peyzaj alanı",
  },
  {
    id: 7,
    name: "Dem Şar Sitesi",
    location: "Diyarbakır, Bağlar",
    district: "Bağlar",
    status: "Teslim Edildi",
    type: "Konut",
    home: true,
    image: "/images/dem-7.JPG",
    slug: "dem-sar-sitesi",
    category: "konut",
    units: "1+1, 2+1 ve 3+1",
    info1: "Diyarbakır Bağlar ilçesi Bağcılar Mahallesi’nde yükselen Dem Şar Sitesi, modern mimarisi, geniş sosyal alanları ve ferah daire seçenekleriyle ayrıcalıklı bir yaşam sunuyor. Toplam 8 bloktan oluşan proje, zemin + 7 kat olmak üzere 8 katlı yapısıyla dikkat çekmektedir.",
    info2: "Toplam 12.680 m² parsel alanı üzerine kurulu proje, geniş hacimli yaşam alanlarıyla hem aileler hem yatırımcılar için ideal bir fırsat sunmaktadır.",
    info3: "Dem Şar Sitesi, konforlu bir yaşamın ötesinde sosyal ve huzurlu bir yaşam vaat eder.",
    feature1: "112 adet 3+1 daire Brüt: 145 m² | Net: 128 m²",
    feature2: "2 adet 2+1 daire Brüt: 100 m² | Net: 85 m²",
    feature3: "22 adet 1+1 daire Brüt: 72.50 m² | Net: 64 m²",
    feature4: "Çocuk oyun parkı",
    feature5: "7/24 güvenlik",
    feature6: "Jeneratör sistemi",
    feature7: "Kamelya ve dinlenme alanları",
    feature8: "Araç otoparkı",
    feature9: "Basketbol sahası",
    feature10: "2.500 m² peyzaj alanı",
    feature11: "2 adet süs havuzu"
  }
];

export const allProjects = [...residentialProjects];

export const news = [
  {
    id: 1,
    title: "Doğayla İç İçe Bungalov Projesi Hayata Geçti",
    image: "/images/dem-news-1.jpg",
    slug: "dem-news-bungalov",
    excerpt: "Şehirden uzaklaşmadan sakin ve huzurlu yaşam imkânı...",
    info1: "Diyarbakır Bağlar Zoğa mevkiinde, Eğertutmaz Deresi’ne sıfır konumda yer alan bungalov projemiz tamamlanmıştır. 25100 m²lik arazi üzerine konumlandırılan proje; doğayla uyumlu mimarisi ve sakin yaşam anlayışıyla, şehirden kopmadan doğanın içinde yaşamak isteyenler için özel olarak tasarlanmıştır.",
    info2: "Doğanın sesi, suyun huzuru ve yeşilin dinginliğiyle şekillenen bu özel proje; hafta sonu kaçamağı, dinlenme alanı ya da alternatif bir yaşam modeli arayanlar için ayrıcalıklı bir yaşam sunmaktadır.",
    feature1: "Konum: Diyarbakır, Bağlar, Zoğa Mevkii",
    feature2: "Arazi Alanı: 25100 m²",
    feature3: "Konsept: Dere kenarı, doğayla uyumlu bungalov yaşam",
    feature4: "Bungalov Alanı: 50 m²",
    feature5: "Eğertutmaz Deresi’ne sıfır, kesintisiz manzara",
    feature6: "Modern, fonksiyonel ve ferah iç mekân tasarımı",
    feature7: "Doğal çevreyle bütünleşen yerleşim planı",
    feature8: "Şehirden uzaklaşmadan sakin ve huzurlu yaşam imkânı",
  },
  {
    id: 2,
    title: "Zoğa’da Özgür Villa Yaşamı Başlıyor",
    image: "/images/dem-news-2.jpg",
    slug: "dem-news-villa",
    excerpt: "Kendi yaşam tarzını inşa etmek isteyenler için...",
    info1: "Diyarbakır Bağlar Zoğa mevkiinde, 203 dönümlük geniş bir alan üzerine konumlanan villa projemiz; standart projelerin ötesinde, özgürlük temelli bir yaşam anlayışı sunuyor.",
    info2: "Bu projede villa yerleşimi ve konumlandırması tamamen size ait. Mimari bütünlüğü korumak adına dış cephe renkleri belirlenen paletle sınırlandırılırken, iç mimari ve iç dizayn tamamen sizin kontrolünüzde şekilleniyor.",
    info3: "Dilerseniz proje bünyesindeki profesyonel ekiplerle anahtar teslim, dilerseniz kendi ekiplerinizle yapım sürecini özgürce yönetebilirsiniz.",
    info4: "Kendi yaşam tarzını inşa etmek isteyenler için Zoğa’da benzersiz ve ayrıcalıklı bir villa deneyimi sizleri bekliyor.",
  },
  {
    id: 3,
    title: "Çarıklı’da Dicle Manzaralı 2+1 Konut Projesi Yükseliyor",
    image: "/images/dem-news-3.jpg",
    slug: "dem-news-sterk-konutlari",
    excerpt: "Hem oturum hem de uzun vadeli kazanç arayanlar için...",
    info1: "Diyarbakır’ın tarihi dokusuyla bütünleşen Çarıklı bölgesinde, tepe hakimiyetine sahip konumuyla öne çıkan 2+1 Net: 86 m²’ lik konut projemiz hayata geçiriliyor. Dicle Nehri manzarasını yaşam alanlarına taşıyan proje; şehirden uzaklaşmadan huzurlu ve prestijli bir yaşam sunmayı hedefliyor.",
    info2: "Modern mimari anlayışıyla tasarlanan daireler; ferah planlaması, gün boyu doğal ışık alan yaşam alanları ve manzarayı maksimum düzeyde değerlendiren balkonlarıyla konforlu bir yaşam vadeder. Güçlü altyapısı ve yüksek yatırım potansiyeline sahip lokasyonuyla proje; hem oturum hem de uzun vadeli kazanç arayanlar için önemli bir fırsat sunmaktadır.",
    feature1: "Projenin Tamamlanması Beklenen Tarih: 2027 – 1. Çeyrek",
  },
  {
    id: 4,
    title: "DEM ÇARŞI Çölgüzeli Depo Projesi Tamamlandı",
    image: "/images/dem-news-4.jpg",
    slug: "dem-news-carsi-abc",
    excerpt: "Lojistik, ticaret ve depolama faaliyetleri için...",
    info1: "Diyarbakır Kayapınar ilçesi Çölgüzeli mevkiinde, 25 dönüm arazi üzerinde inşa edilen DEM ÇARŞI depo projemiz başarıyla tamamlanarak kullanıma hazır hale getirilmiştir. Stratejik konumu sayesinde şehir içi ve şehirlerarası ulaşım akslarına hızlı erişim imkânı sunan proje; lojistik, ticaret ve depolama faaliyetleri için üst düzey çözümler sağlamaktadır.",
    info2: "Güçlü altyapısı ve bölgenin yükselen ticari potansiyeli ile proje; hem aktif kullanım hem de uzun vadeli yatırım açısından yüksek değer sunmaktadır.",
    feature1: "Toplam Alan: 25 dönüm",
    feature2: "A Blok: Net 400 m² – 7 adet dükkân",
    feature3: "B Blok: Net 400 – 800 m² – 10 adet dükkân",
    feature4: "C Blok: Net 580 – 615 m² – 12 adet dükkân",
    feature5: "Asma Katlı, Yüksek tavanlı yapı",
    feature6: "Geniş yükleme–boşaltma alanları",
    feature7: "Elektrik, su, doğalgaz, internet, kanalizasyon, yol ve çevre düzenlemesi tamamlanmış altyapı",
    feature8: "Farklı sektörlere uygun, esnek ve ölçeklenebilir kullanım",
  },
  {
    id: 5,
    title: "DEM ÇARŞI Çölgüzeli Depo 2. Etap Projesi (D Blok) Tamamlandı",
    image: "/images/dem-news-5.JPG",
    slug: "dem-news-carsi-d",
    excerpt: "Lojistik, depolama ve ticari kullanıma uygun planlama için...",
    info1: "Diyarbakır Kayapınar ilçesi Çölgüzeli mevkiinde, toplam 8 dönüm arazi üzerinde hayata geçirilen Depo 2. Etap Projesi (D Blok) başarıyla tamamlanarak kullanıma hazır hale getirilmiştir. Tüm altyapı çalışmaları eksiksiz şekilde tamamlanan proje, lojistik ve ticari faaliyetler için ideal bir çözüm sunmaktadır.",
    info2: "Konumu ve fonksiyonel yapısıyla bölgenin yükselen ticari potansiyeline katkı sağlayan Depo 2. Etap Projesi; işletmeler için verimli kullanım, yatırımcılar için sürdürülebilir değer sunmaktadır.",
    feature1: "Proje Alanı: 8 dönüm",
    feature2: "Etap: 2. Etap – D Blok",
    feature3: "Toplam Dükkân Sayısı: 12 adet",
    feature4: "Dükkân Alanları: Net 400 m² – 800 m² aralığında",
    feature5: "Lojistik, depolama ve ticari kullanıma uygun planlama",
    feature6: "Güçlü ve tamamlanmış altyapı (elektrik, su, doğalgaz, internet, yol, çevre düzenlemesi)",
    feature7: "Modern yapı anlayışı ve işlevsel tasarım",
    feature8: "Şehir içi ulaşım akslarına yakın, erişilebilir konum",
  }
];

export const offices = [
  {
    id: 1,
    name: "Dem Merkez Ofis",
    address: "Bağcılar Mah. Aramtigran Bulvarı Meram 4 yapı Koop. A/9blok altı, 21090 Bağlar/Diyarbakır",
    workDays: "Haftanın 7 Günü",
    workHours: "08:00-17:00",
    email: "demsahintepe@gmail.com",
    phone: "+90 501 648 0821",
    city: "Diyarbakır",
    category: "Merkez",
    mapLoc: "https://www.google.com/maps/place/Dem+kuyumculuk/@37.9117602,40.1492627,779m/data=!3m2!1e3!4b1!4m6!3m5!1s0x40751ffd4483e9bb:0x66b1ce34ff062f52!8m2!3d37.9117602!4d40.1492627!16s/g/11h7dcx6ys?entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoASAFQAw=="
  },
  {
    id: 2,
    name: "Dem Çarşı",
    address: "Bağcılar, 1259 Sk. DEMÇARŞI SİTESİ NO 4/A, 21090 Bağlar/Diyarbakır",
    workDays: "Haftanın 7 Günü",
    workHours: "09:00-19:00",
    email: "demgidacilar@hotmail.com",
    phone: "+90 532 379 5324",
    city: "Diyarbakır",
    category: "Satış Ofisi",
    mapLoc: "https://www.google.com/maps/place/DEM+%C3%87AR%C5%9EI/@37.9078831,40.0946551,779m/data=!3m2!1e3!4b1!4m6!3m5!1s0x407519987db54f61:0xc0d3471cfb7b128b!8m2!3d37.9078831!4d40.0946551!16s/g/11xzxqld38?entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoASAFQAw=="
  },
  {
    id: 3,
    name: "Dem Sterk Konutları",
    address: "Çarıklı Mh. 1109/3 Sk. 21100 Sur/Diyarbakır",
    workDays: "Haftanın 7 Günü",
    workHours: "09:00-19:00",
    email: "demsahintepe@gmail.com",
    phone: "+90 501 648 0821",
    city: "Diyarbakır",
    category: "Satış Ofisi",
    mapLoc: "https://maps.app.goo.gl/dvkSaU2ZSiNmCns3A",
    image: "/images/IMG_4421.jpg"
  }
];

export const cities = ["Tümü", "Diyarbakır"];
export const districtes = ["Tümü", "Bağlar", "Çarıklı", "Kayapınar"];
export const projectCategories = ["Tümü", "Bungalov", "Depo", "Konut", "Villa"];
